















































































































































































































































































































































































































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import BaseContainer from '@/components/BaseContainer.vue';
import StatusPanel from '@/views/project/components/StatusPanel.vue';
import BaseInfoPanel from '@/components/BaseInfoPanel.vue';
import { Project, Carrier,ProjectManager } from '@/http';
import ButtonPanel from '@/components/ButtonPanel.vue';
import CspDialog from '@/components/CspDialog.vue';
import { formRules } from '@/common/util/validator';
import { default as DataPanel } from '@/components/DataPanel.vue';
import publicFunc from '../../common/util/publicFunc';
@Component({
    components: {
        BaseContainer,
        StatusPanel,
        BaseInfoPanel,
        ButtonPanel,
        CspDialog,
        DataPanel,
    },
})
export default class ProjectDetail extends Vue {
    public winVisible = false;
    public formDataWin: any = { winRemark: '' };
    public loading: boolean = false;
    public adjustCarrierVisible = false;
    public requoteVisible = false;
    public title: string = '新增、编辑、查看项目信息，项目信息包括基本信息、收货信息、货物信息，其中货物信息支持批量导入快捷方式';
    public cspdiaConfig: any = {
        cspDialogVisible: false,
        title: '询价单终结',
        content: '确认终结询价单？',
    };
    public publicFunc: any = publicFunc;
    public formRules = formRules;
    public id: any = '';
    public name: any = '';
    public detailData: any = {};
    public goodsList: any = [];
    public formDataRequote: any = {};
    public async created() {
        this.id = this.$route.query.id;
        this.name = this.$route.query.name;
        // let res = await Carrier.GetList({ count: -1 });
        // this.carrierList = res.data;
        this.reload();
    }

    public async init() {
        this.id = this.$route.query.id;
        this.name = this.$route.query.name;
        // let res = await Carrier.GetList({ count: -1 });
        // this.carrierList = res.data;
        this.reload();
    }

    // toContract() {
    //     this.$router.push({
    //         path: '/contractManage',
    //     });
    // }

    // toOrderPage() {
    //     this.$router.push({
    //         path: '/addOrder',
    //         query: {
    //             projectId: this.id,
    //             type: 'project',
    //         },
    //     });
    // }

    is150 = false;
    // 方法
    public ratio = 0;
    detectZoom() {
        this.ratio = 0;
        const screen: any = window.screen;
        const ua = navigator.userAgent.toLowerCase();
        if (window.devicePixelRatio !== undefined) {
            this.ratio = window.devicePixelRatio;
        } else if (~ua.indexOf('msie')) {
            if (screen.deviceXDPI && screen.logicalXDPI) {
                this.ratio = screen.deviceXDPI / screen.logicalXDPI;
            }
        } else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
            this.ratio = window.outerWidth / window.innerWidth;
        }
        if (this.ratio) {
            this.ratio = Math.round(this.ratio * 100);
        }
        // console.log('this.ratio' + this.ratio);
        if (this.ratio >= 140) {
            this.is150 = true;
        } else {
            this.is150 = false;
        }
    }

    public allCarrierBtnList: any = [];
    public allCarrierBtnListId: any = [];
    public tableList: any = [];
    public projectCarrierList: any = [];
    reload() {
        this.tableData = [];
        this.tableList = [];
        this.projectCarrierList = [];
        this.isChangeCarrier = false;
        ProjectManager.GetProjectDetail(this.id).then((res) => {
            console.log(res,"列表")
            this.detailData = res;
            this.goodsList = this.detailData.goodsList;
            this.projectCarrierList = res.projectCarrierList;
            // let carLengthArr = res.carLength.split(',');
            // carLengthArr.forEach((item) => {
            //     this.tableList.push({
            //         carLength: item,
            //         price: '',
            //     });
            // });

            console.log(this.goodsList,'2222222222222222')
            // if (this.detailData.projectQuotes && this.detailData.projectQuotes.length > 0) {
            //     this.detailData.projectQuotes.forEach((item) => {
            //         this.tableData.push({
            //             carrierName: item.carrierName,
            //             timesIndex: item.timesIndex,
            //             quotes: item.quotes,
            //             isWin: item.isWin,
            //             isNew: item.isNew,
            //         });
            //     });
            //     this.tableData[this.tableData.length - 1].canZhongbiao = true;
            // }
            let skip = 0;
            this.detailData.goodsList.map((item, index) => {
                item.index = skip++ + 1;
            });

            // this.getSpanArr(this.tableData);
            // this.formData.carrierIds = [];
            // res.projectCarrierList.forEach((item) => {
            //     this.formData.carrierIds.push(item.carrierId);
            // });
            // this.dynamicTags = [];

            // this.formData.carrierIds.forEach((item) => {
            //     let res = this.carrierList.filter((v) => v.id == item)[0];
            //     this.dynamicTags.push({
            //         name: res.name,
            //         id: res.id,
            //     });
            // });

            // this.allCarrierBtnList = [];
            // this.allCarrierBtnListId = [];
            // this.carrierList.forEach((i) => {
            //     this.allCarrierBtnList.push(i.name);
            //     this.allCarrierBtnListId.push({
            //         id: i.id,
            //         name: i.name,
            //     });
            // });
        });
    }

    public curCarrierBtnList = [];
    public async mounted() {
        this.detectZoom();
        this.$nextTick(() => {
            window.addEventListener('resize', () => {
                // 监听浏览器窗口大小改变
                this.detectZoom();
                // 浏览器变化执行动作
            });
        });
    }
    public spanArr = [];
    public pos = 0;
    getSpanArr(data) {
        this.spanArr = [];
        for (var i = 0; i < data.length; i++) {
            if (i === 0) {
                this.spanArr.push(1);
                this.pos = 0;
            } else {
                // 判断当前元素与上一个元素是否相同  inAccessCode（批次字段）
                if (data[i].carrierName === data[i - 1].carrierName) {
                    this.spanArr[this.pos] += 1;
                    this.spanArr.push(0);
                } else {
                    this.spanArr.push(1);
                    this.pos = i;
                }
            }
        }
    }

    public requoteClose() {
        this.requoteVisible = false;
    }

    public async saveRequote() {
        if (this.currentBtn.length == 0) {
            this.$message.warning('请选择承运商');
        } else {
            let carrierIds = [];
            this.currentBtn.forEach((i) => {
                let res = this.allCarrierBtnListId.filter((v) => v.name == i)[0];
                carrierIds.push(res.id);
            });
            await Project.BackQuote({
                projectId: this.id,
                carrierIds: carrierIds,
            });
            this.$message.success('定向询价承运商调整成功！');
            this.$router.push('/SingleProject');
        }
    }
    public $refs: {
        formData: HTMLFormElement;
        formDataWin: HTMLFormElement;
    };

    public saveAdjustCarrier() {
        this.$refs.formData.validate(async (valid) => {
            if (valid) {
                await Project.UpdateCarriers({
                    projectId: this.id,
                    carrierIds: this.formData.carrierIds,
                });
                this.$message.success('定向询价承运商调整成功！');
                this.$router.push('/SingleProject');
            }
        });
    }

    public isChangeCarrier = false;
    public changeCarrier() {
        this.isChangeCarrier = true;
    }
    public formData: any = { carrierIds: [] };
    public dynamicTags = [];
    handleDelTag(tag) {
        let flag = true;
        try {
            this.detailData.projectQuotes.forEach((i) => {
                if (i.carrierName == tag.name) {
                    flag = false;
                    this.$message.warning('该承运商已报价，无法删除!');
                    throw Error();
                }
            });
        } catch (e) {}
        if (flag) {
            this.formData.carrierIds = [];
            this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
            this.dynamicTags.forEach((item) => {
                this.formData.carrierIds.push(item.id);
            });
            this.oldData = JSON.parse(JSON.stringify(this.formData.carrierIds));
        }
    }
    public carrierChange(data) {
        let flag = true;
        let arr1 = [];
        let arr2 = [];
        if (this.formData.carrierIds.length >= this.oldData) {
            arr1 = this.formData.carrierIds;
            arr2 = this.oldData;
        } else {
            arr1 = this.oldData;
            arr2 = this.formData.carrierIds;
        }
        let res = [];
        res.push(
            arr1.filter((item) => {
                return !arr2.includes(item);
            })
        );
        try {
            this.detailData.projectQuotes.forEach((i) => {
                if (i.carrierId == res[0]) {
                    flag = false;
                    this.$message.warning('该承运商已报价，无法删除!');
                    this.formData.carrierIds = JSON.parse(JSON.stringify(this.oldData));
                    throw Error();
                }
            });
        } catch (e) {}
        if (flag) {
            this.dynamicTags = [];
            this.formData.carrierIds.forEach((item) => {
                let res = this.carrierList.filter((v) => v.id == item)[0];
                this.dynamicTags.push({
                    name: res.name,
                    id: res.id,
                });
            });
            this.oldData = JSON.parse(JSON.stringify(this.formData.carrierIds));
        }
    }
    public tableData: any = [];
    public colData: any = [];

    public adjustCarrierClose() {
        this.$refs.formData.resetFields();
        this.adjustCarrierVisible = false;
    }

    public oldData: any = [];
    //调整承运商
    adjustCarrier() {
        this.adjustCarrierVisible = true;
        this.oldData = JSON.parse(JSON.stringify(this.formData.carrierIds));
        this.dynamicTags = [];

        this.formData.carrierIds.forEach((item) => {
            let res = this.carrierList.filter((v) => v.id == item)[0];
            this.dynamicTags.push({
                name: res.name,
                id: res.id,
            });
        });
    }
    //一键催报
    async reminder() {
        await Project.Urge(this.id);
        this.$message.warning('单笔询价催报成功！');
    }
    //承运商重新报价
    requote() {
        this.requoteVisible = true;
        let currBtnName = [];
        // this.projectCarrierList.forEach((item) => {
        //     currBtnName.push(item.carrierName);
        // });
        this.currentBtn = currBtnName;

        this.curCarrierBtnList = [];
        this.currentBtn.forEach((i) => {
            let res = this.allCarrierBtnList.filter((v) => v == i)[0];
            this.curCarrierBtnList.push(res);
        });
    }
    //一键否决
    reject() {
        this.$confirm('承运商报价全部拒绝!', '一键否决', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        })
            .then(() => {
                Project.RejectAllQuote(this.id).then(() => {
                    this.$message.success('单笔询价招标失败！');
                    this.$router.push('/SingleProject');
                });
            })
            .catch(() => {});
    }
    loadingEffect = [];
    public winTip: any = '';
    public winRemark: any = '';

    public timesIndex: any = '';
    public tag = false;
    public carrierId: any = '';
    public bidding(row, tag) {
        this.tag = tag;
        this.timesIndex = row.timesIndex;
        this.carrierId = row.quotes[0].carrierId;
        console.log('row' + JSON.stringify(row));
        if (tag) {
            let str = '';
            row.quotes.forEach((item) => {
                if (item.price) {
                    str += item.carLength + '中标价:' + item.price + ' , ';
                }
            });
            // str = str.substring(0, str.lastIndexOf(','));
            this.winTip = str + '   确认' + row.carrierName + '中标?';
        } else {
            this.winTip = '确认取消' + row.carrierName + '中标?';
        }

        this.formDataWin.winRemark = '';
        this.winVisible = true;
    }
    public async saveWin() {
        this.$refs.formDataWin.validate(async (valid) => {
            if (valid) {
                if (this.tag) {
                    await Project.Win({
                        projectId: this.id,
                        carrierId: this.carrierId,
                        timesIndex: this.timesIndex,
                        winRemark: this.formDataWin.winRemark,
                    });
                    this.$message.success('询价单招标成功！');
                } else {
                    await Project.CancelWin({
                        projectId: this.id,
                        carrierId: this.carrierId,
                        timesIndex: this.timesIndex,
                        cancelRemark: this.formDataWin.winRemark,
                    });
                    this.$message.success('询价单取消成功!');
                }

                this.winVisible = false;
                this.init();
                // this.$router.push('/SingleProject');
            }
        });
    }
    winClose() {
        this.formDataWin.winRemark = '';
        this.winTip = '';
        this.$refs.formDataWin.resetFields();
        this.winVisible = false;
    }
    cellClass({ row, column, rowIndex, columnIndex }) {
        if (this.detailData.statusStr == '招标成功') {
            if (row.isWin && columnIndex != 0) {
                return 'font-weight:700;color:#30AD83';
            } else {
                return '';
            }
        }
    }

    /**新增询价单 */
    public async addProject() {
        this.dialogBtn = 'save';
        this.cspdiaConfig = {
            cspDialogVisible: true,
            title: '询价单发布',
            content: '确认发布询价单？',
        };
    }
    // 编辑项目
    editProject(){
        this.$router.push({
            path:'/AddProject',
            query:{
                id:this.id,
                type:'edit'
            }
        })
    }
    // 启动执行
    executeProject(){
        this.dialogConfig5  ={
            title:'该项目已执行',
            show:true,
        }
    }
   // 完成项目单
    finishProject() {
          this.dialogConfig4 = {
            title: '该项目已完成',
            show: true,
        };
        // this.$router.push({
        //     path: '/projectManager',
        //     query: {
        //         id: this.id,
        //         type: 'finish',
        //     },
        // });
    }
     confirmOk4() {
        ProjectManager.finishProject(this.id).then(() => {
            this.$message.success('项目完成');
            this.$router.push('/projectManager');
        });
        this.dialogConfig4 = {
            title: '',
            show: false,
        };
    }

   confirmOk5(){
       ProjectManager.StartProject(this.id).then(()=>{
           this.$message.success('项目已执行');
           this.$router.push('/projectManager')
       })
       this.dialogConfig5 = {
           title:'',
           show:false,
       }
   }
    public dialogBtn: string = '';
    /**终结询价单 */
    confirmOk3() {
        Project.EndProject(this.id).then(() => {
            this.$message.success('项目终结成功');
            this.$router.push('/projectManager');
        });
        this.dialogConfig3 = {
            title: '',
            show: false,
        };
    }
    endProject() {
        this.dialogConfig3 = {
            title: '终结项目',
            show: true,
        };
        // this.$confirm('确认终结该询价单?', '询价单终结', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning',
        // })
        //     .then(() => {
        //         Project.EndProject(this.id).then(() => {
        //             this.$message.success('询价单终结成功');
        //             this.$router.push('/SingleProject');
        //         });
        //     })
        //     .catch(() => {});
    }
    public dialogConfig2 = {
        title: '',
        show: false,
    };
    public dialogConfig3 = {
        title: '',
        show: false,
    };
     public dialogConfig4 = {
        title: '',
        show: false,
    };
      public dialogConfig5 = {
        title: '',
        show: false,
    };
    confirmClose2() {
        this.dialogConfig2 = {
            title: '',
            show: false,
        };
    }
    confirmClose3() {
        this.dialogConfig3 = {
            title: '',
            show: false,
        };
    }
     confirmClose4() {
        this.dialogConfig4 = {
            title: '',
            show: false,
        };
    }
     confirmClose5() {
        this.dialogConfig5 = {
            title: '',
            show: false,
        };
    }
    confirmOk2() {
        Project.DelProject(this.id).then(() => {
            this.$message.success('项目删除成功');
            this.$router.push('/projectManager');
        });
        this.dialogConfig2 = {
            title: '',
            show: false,
        };
    }
    /**删除询价单 */
    deleteProject() {
        this.dialogConfig2 = {
            title: '删除项目',
            show: true,
        };
        // this.$confirm('确认删除该询价单?', '询价单删除', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning',
        // })
        //     .then(() => {
        //         Project.DelProject(this.id).then(() => {
        //             this.$message.success('询价单删除成功');
        //             this.$router.push('/SingleProject');
        //         });
        //     })
        //     .catch(() => {});
    }

    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        if (columnIndex === 0) {
            const _row = this.spanArr[rowIndex];
            const _col = _row > 0 ? 1 : 0;
            return {
                rowspan: _row,
                colspan: _col,
            };
        }
    }
    public currentBtn: any = [];

    public editForm: any = {};
    public fileList: any = [];
    public goodsForm: any = {};

    cspdiaClose() {}

    back() {
        this.$router.push('/projectManager');
    }

    viewFile(item) {
        if (publicFunc.getExtension2(item.name)) {
            window.open(`https://view.officeapps.live.com/op/view.aspx?src=${item.path}`);
        } else {
            window.open(item.path);
        }
    }
    rowStyle({ row, rowIndex }) {
        Object.defineProperty(row, 'rowIndex', {
            value: rowIndex,
            writable: true,
            enumerable: false,
        });
    }
    public processStatus: boolean = false;
    public processList = [];
    public takeTime = null;
    public firData = null;
    public SecData = null;
    public d: number = 0;
    public h: number = 0;
    public m: any = 0;
    public s: any = 0;
    public time: string = '';
    public timer: any = null;

    async getprocess(e) {
        e.stopPropagation();
        this.processStatus = !this.processStatus;
        if (this.processStatus) {
            this.processList = [];
            let res = await Project.GetTracks(this.id);
            this.processList = res.tracks;
            this.takeTime = this.processList[0].time;
            this.firData = this.processList[0].time;
            this.SecData = this.processList[this.processList.length - 1].time;
            if (res.isEnd) {
                this.countTime2();
            } else {
                this.countTime();
            }

            console.log('this.processList' + JSON.stringify(this.processList));
        }
    }

    countTime() {
        //获取当前时间
        var date = new Date();
        var now = date.getTime();
        //设置截止时间
        var endDate = new Date(Date.parse(this.SecData.replace(/-/g, '/')));
        var end = endDate.getTime();
        //时间差
        var leftTime = now - end;
        //定义变量 d,h,m,s保存倒计时的时间

        this.d = Math.floor(leftTime / 1000 / 60 / 60 / 24);
        this.h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
        this.m = Math.floor((leftTime / 1000 / 60) % 60);
        this.s = Math.floor((leftTime / 1000) % 60);
        this.time = '耗时' + this.d + '天' + this.h + '小时' + this.m + '分' + this.s + '秒';
        this.timer = setTimeout(this.countTime, 1000);
    }

    countTime2() {
        var nowData = new Date(Date.parse(this.firData.replace(/-/g, '/')));
        var now = nowData.getTime();
        var endDate = new Date(Date.parse(this.SecData.replace(/-/g, '/')));
        var end = endDate.getTime();
        var leftTime = now - end;
        //定义变量 d,h,m,s保存倒计时的时间
        console.log('leftTime' + leftTime);

        this.d = Math.floor(leftTime / 1000 / 60 / 60 / 24);
        this.h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
        this.m = Math.floor((leftTime / 1000 / 60) % 60);
        this.s = Math.floor((leftTime / 1000) % 60);
        this.time = '耗时' + this.d + '天' + this.h + '小时' + this.m + '分' + this.s + '秒';
    }
    @Watch('processStatus')
    processStatusChange() {
        if (this.processStatus == false) {
            if (this.timer) {
                clearTimeout(this.timer);
            }
        }
    }

    public carrierList = [];
    getCarrierList() {
        // CspProject.getLoadType({ typeName: '装车要求' }).then((res) => {
        //     this.carrierList = res.map((v) => {
        //         return v.stringData;
        //     });
        // });
    }
    updateBtn(item, index) {
        console.log('item' + JSON.stringify(item));
        if (this.currentBtn.includes(item)) {
            this.currentBtn.splice(this.currentBtn.indexOf(item), 1);
        } else {
            this.currentBtn.push(item);
        }
        console.log('this.currentBtn' + JSON.stringify(this.currentBtn));
    }

    downLoad(path) {
        window.open(path);
    }
    public total = 0;
    public paginationOptions = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public pageSizes = [10];
    public lastPageNum = 0;
    public pageSize: number = 10;
    public firstPageBtnDisabled = true;
    public lastPageBtnDisabled = false;
    public handleCurrentChange(val) {
        console.log('onPaginationChange', val);
        this.firstPageBtnDisabled = val === 1 ? true : false;
        this.lastPageBtnDisabled = val === Math.ceil(this.total / this.paginationOptions.count) ? true : false;
        this.paginationOptions.currentPage = val;
        this.paginationOptions.skip = (this.paginationOptions.currentPage - 1) * this.paginationOptions.count;
        console.log('this.paginationOptions~', this.paginationOptions);
    }
    public handleSizeChange(val) {
        console.log('handleSizeChangeval' + JSON.stringify(val));

        this.paginationOptions.count = val;
        this.paginationOptions.currentPage = 1;
        this.handleCurrentChange(this.paginationOptions.currentPage);
        if (Math.ceil(this.total / val) < this.paginationOptions.currentPage) {
            this.paginationOptions.skip = 0;
        } else {
            this.paginationOptions.skip = (this.paginationOptions.currentPage - 1) * this.paginationOptions.count;
        }
    }
}
